<app-loader [isLoading]="loading"></app-loader>
<div class="d-flex flex-column dialog-wrapper">
  <div *ngIf="hasCamera">
    <ng-container *ngIf="imageTaken">
      <img [src]="capturedImage" alt="captured image" />
    </ng-container>
    <ng-container *ngIf="!imageTaken">
      <video #videoRef></video>
    </ng-container>
    <canvas #canvasRef width="640" height="480" style="display: none"></canvas>
  </div>
  <div *ngIf="!hasCamera" class="noCameraFoundText">
    No camera found on the device.
  </div>
  <div class="action-button p-1 gap-3 mt-1">
    <div class="close-modal-btn" (click)="closeCaptureCameraPopup()">Close</div>
    <div *ngIf="hasCamera">
      <ng-container *ngIf="imageTaken">
        <button class="capture-modal-btn" (click)="onClickProceed()">
          Proceed
        </button>
      </ng-container>
      <ng-container *ngIf="!imageTaken">
        <button class="capture-modal-btn" (click)="handleCapture()">
          Capture
        </button>
      </ng-container>
    </div>
  </div>
</div>
